"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MyContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("./../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var MyContext = exports.MyContext = /*#__PURE__*/_react["default"].createContext({});
// 新增按钮组件
function FixButton(props) {
  var btnLink = props.btnLink,
    onCallBack = props.onCallBack;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, btnLink.txt && (/*#__PURE__*/_react["default"].createElement("div", {
    className: "navigator-link",
    onClick: onCallBack
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "javascript:void(0);"
  }, btnLink.txt))));
}
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    className = props.className,
    children = props.children,
    onClick = props.onClick,
    height = props.height,
    width = props.width,
    style = props.style,
    btnLink = props.btnLink,
    onCallBack = props.onCallBack,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "className", "children", "onClick", "height", "width", "style", "btnLink", "onCallBack"]);
  var innerRef = (0, _react.useRef)(null);
  var _a = (0, _react.useState)(false),
    isFixed = _a[0],
    setIsFixed = _a[1];
  var _b = (0, _react.useState)(true),
    rightStatus = _b[0],
    setRightStatus = _b[1];
  var _c = (0, _react.useState)(true),
    leftStatus = _c[0],
    setLeftStatus = _c[1];
  var val = {
    x: 0
  };
  var scale = 0.1;
  var valDirectionRight = true;
  var _runRequestFunc = function runRequestFunc(getInnerChild_1, deadline, _promise, currentScroll) {
    requestAnimationFrame(function () {
      // if (!leftRef.current) return;
      val = (0, _utils.animates)({
        x: currentScroll || getInnerChild_1.scrollLeft
      }, deadline);
      getInnerChild_1.scrollLeft = val.x;
      if (valDirectionRight && deadline - val.x > scale) {
        _runRequestFunc(getInnerChild_1, deadline, _promise, Math.fround(val.x));
      } else if (!valDirectionRight && deadline - val.x < -scale) {
        _runRequestFunc(getInnerChild_1, deadline, _promise, Math.fround(val.x));
      } else {
        var result = {
          left: true,
          right: true
        };
        /**
         * 计算左侧箭头
         */
        if (val.x < 10) {
          result.left = true;
        } else {
          result.left = false;
        }
        /**
         * 计算右侧箭头
         */
        if (val.x > getInnerChild_1.scrollWidth - getInnerChild_1.clientWidth) {
          result.right = true;
        } else {
          result.right = false;
        }
        /**
         * 当前统一返回状态
         */
        _promise.resolve(result);
      }
      displayRight();
    });
  };
  var _requestAnimationFrame = function _requestAnimationFrame(getInnerChild_1, deadline) {
    valDirectionRight = deadline > getInnerChild_1.scrollLeft;
    /**
     * Promise resolve status
     */
    return new Promise(function (resolve, reject) {
      _runRequestFunc(getInnerChild_1, deadline, {
        resolve: resolve,
        reject: reject
      });
    });
  };
  var moveToNode = function moveToNode() {
    var getInnerChild = innerRef.current;
    var getInnerChild_1 = getInnerChild.childNodes[1];
    return getInnerChild_1;
  };
  /**
   * 移动端计算距离，执行右侧隐藏
   * @param deadline
   */
  var moveToFunc = function moveToFunc(deadline) {
    _requestAnimationFrame(moveToNode(), deadline).then(function (status) {
      setRightStatus(status.right);
      setLeftStatus(status.left);
    });
  };
  /**
   * 判断导航容器宽度
   */
  var displayRight = function displayRight() {
    if (moveToNode().scrollWidth === 1440) {
      setRightStatus(true);
    } else {
      setRightStatus(false);
    }
  };
  var noticeHeight;
  var noticeShow = function noticeShow() {
    var notice = document.getElementById('notice');
    var KingBird = document.getElementById('KingBird');
    noticeHeight = notice ? notice.clientHeight : -0.5;
    if (KingBird) {
      KingBird.style.top = noticeHeight + "px";
    }
  };
  (0, _react.useEffect)(function () {
    noticeShow();
    displayRight();
    var fixFunc = (0, _utils.throttle)(function () {
      var _a;
      var domHeight = ((_a = document.getElementById('KingBird')) === null || _a === void 0 ? void 0 : _a.offsetTop) || 0;
      var topNav = document.querySelector('.ci-nav-bottom');
      var topNavList = document.querySelectorAll('.ci-nav-popup');
      if (domHeight - (0, _utils.getWinScrollY)() <= 0.5) {
        setIsFixed(true);
        // 解决顶部菜单栏Hover问题
        if (topNavList) {
          for (var i = 0; i < topNavList.length; i++) {
            // @ts-ignore
            topNavList[i].style.display = 'none';
          }
        }
      } else {
        setIsFixed(false);
      }
      if (topNav) {
        var topDistance = domHeight - (0, _utils.getWinScrollY)();
        topNav.style.top = topDistance <= 60 ? topDistance - 60 + "px" : '0px';
        displayRight();
      }
    }, 1);
    fixFunc();
    window.addEventListener('scroll', fixFunc);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    id: 'KingBird',
    className: (0, _classnames["default"])('flex-default-king-bird-container', className, isFixed && 'flex-default-king-bird-index'),
    style: style
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-king-bird'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'inseparable_bird'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'middle'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'inner',
    ref: innerRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('left', {
      'arrow--hidden': leftStatus
    })
  }, /*#__PURE__*/_react["default"].createElement("img", {
    onClick: function onClick() {
      moveToFunc(moveToNode().scrollLeft - 300);
    },
    src: 'https://main.qcloudimg.com/qcintl-cms/154/1624937747927/b05f213ab6e01c8e7fe45def71cf4776.svg'
  })), /*#__PURE__*/_react["default"].createElement(MyContext.Provider, {
    value: {
      moveToNode: moveToNode,
      requestanimationframefunc: _requestAnimationFrame
    }
  }, /*#__PURE__*/_react["default"].createElement(MyContext.Consumer, null, function (value) {
    return _react["default"].Children.map(children, function (child) {
      // @ts-ignore
      return /*#__PURE__*/_react["default"].cloneElement(child, value);
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('right', {
      'arrow--hidden': rightStatus
    })
  }, /*#__PURE__*/_react["default"].createElement("img", {
    onClick: function onClick(e) {
      e.preventDefault();
      moveToFunc(moveToNode().scrollLeft + 300);
    },
    src: 'https://main.qcloudimg.com/qcintl-cms/154/1624937747927/b05f213ab6e01c8e7fe45def71cf4776.svg'
  }))), isFixed && /*#__PURE__*/_react["default"].createElement(FixButton, {
    btnLink: btnLink,
    onCallBack: onCallBack
  })))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = exports["default"] = Thumbnail;